export default __webpack_public_path__ + "static/MAGIC-logo-480998d08fbd2d1ed0ea5840bb61dd91.png";